import getStringEnvVar from 'lib/getStringEnvVar';

const isEnvProduction = () => getStringEnvVar('NODE_ENV') === 'production';

export default isEnvProduction;
